var ProductQuestionsComponent = Vue.component('product-questions', {
    props: ['productId'],
    data: function () {
        return {
            questions: [],
            questionsLoaded: false,
            questionsEmpty: false
        };
    },
    methods:{
        loadQuestions: function () {
            $(function() {
                $.post(Eshop.options.baseUrl + '/rshop-api/products/questions', { product_id: this.productId }, function (response) {
                    this.questions = response.result.questions;
                    this.questionsLoaded = true;
                    if (this.questions.length == 0) {
                        this.questionsEmpty = true;
                    }
                }.bind(this), 'json');
            }.bind(this));
        }
    }
});